import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Математика. 5-6 класс",
        subject: "Формирование вычислительных навыков при изучении темы «Положительные и отрицательные числа»",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Формирование вычислительных навыков при изучении темы «Положительные и отрицательные числа»",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Буцко Елена Владимировна",
                grade: "научный сотрудник лаборатории математического общего образования ФГБНУ «ИСРО»",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: `<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>
                                <p>Выбор темы кейса обусловлен тем, что формирование вычислительных умений и навыков при изучении темы «Положительные и отрицательные числа» традиционно вызывает целый ряд трудностей у обучающихся. Такие вычислительные навыки очень важны. Они  понадобятся школьникам для дальнейшего изучения не только алгебры и геометрии, но и других предметов: например, физики и химии. </p>
                                </div>
                                 <div style='padding: 2.4rem;'>
                                    <p>Среди планируемых результатов кейса:</p>
                                    <ul>
                                    <li>личностные: развивать интерес к изучению темы и мотивировать желание применять приобретенные знания и умения, формировать умение контролировать процесс и результат учебной и математической деятельности. </li>
                                    <li>метапредметные: формировать умение определять способы действий в рамках предложенных условий и требований, корректировать свои действия в соответствии с изменяющейся ситуацией. </li>
                                    <li>предметные: формировать вычислительные навыки обучающихся по теме «Положительные и отрицательные числа», систематизировать навыки применения свойств арифметических действий с рациональными числами.</li>
                                    </ul>
                                    </div>`
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4",
            contentBefore: [{
                type: "text",
                text: `<p>Информационные технологии и гаджеты очень прочно вошли в современный мир. Многие процессы, которые раньше были для человека естественными, сейчас вытеснили приборы и девайсы. Но это совсем не значит, что многие навыки, в частности вычислительные, теперь человеку не нужны.</p>
                <p>Функция этого навыка состоит не только в умении выполнять арифметические операции. Вычисления помогают человеку решать часть повседневных ситуаций, в которых одним калькулятором не обойтись. Ведь человеку необходимо проводить анализ и принимать решения.</p>
                <p>К моменту изучения положительных и отрицательных чисел у шестиклассников уже должны быть прочно сформированы вычислительные навыки с действиями с натуральными числами, десятичными и обыкновенными дробями. Поэтому этап формирования навыков работы с положительными и отрицательными числами состоит не только в овладении алгоритмами действий с этими числами, а являются обобщающим и систематизирующим этапом работы над рациональными числами.</p>
                <p style="text-align: center;"><img src="images/pic1.png"></p>
                <p>Достижения уровня сформированности вычислительных навыков проверяются не только по окончании изучения курса математики 5-6 класса, на государственной итоговой аттестации, а также являются неотъемлемой частью единого государственного экзамена базового и углублённого уровней. На ЕГЭ представлены задания на выполнение вычислений с рациональными числами.</p>
                <p style="text-align: center;"><img src="images/pic2.png"></p>
                <p>Анализ результатов выполнения этих заданий в 2022 году показал, что средний процент их выполнения составил от 69,8 до 73. Это говорит о том, что, с одной стороны, выпускники справляются с простейшими вычислениями с рациональными числами, а с другой — процент выполнения по сравнению другими заданиями значительно ниже. Таким образом, факты свидетельствует о недостаточно сформированных вычислительных навыках выпускников.</p>
                <p>По мнению экспертов, для достижения высокого уровня сформированности вычислительных навыков учителю необходимо реализовать системный  методический подход при изучении темы «Положительные и отрицательные числа».</p>
                <p style="text-align: center; font-weight: bold;">Анализ результатов выполнения заданий на ЕГЭ в 2022 г.</p>
                <p style="text-align: center">
                <table style="border-collapse: collapse;">
                <tr>
                    <td style="border: 1px solid black; padding: 1vh;">Номер задания</td>
                    <td style="border: 1px solid black; padding: 1vh;">Проверяемые требования (умения)</td>
                    <td style="border: 1px solid black; padding: 1vh;">Средний процент выполнения</td>
                </tr>
                <tr>
                    <td style="border: 1px solid black; padding: 1vh;">1</td>
                    <td style="border: 1px solid black; padding: 1vh;">Умения выполнять вычисления и преобразования</td>
                    <td style="border: 1px solid black; padding: 1vh;">73</td>
                </tr>
                <tr>
                    <td style="border: 1px solid black; padding: 1vh;">2</td>
                    <td style="border: 1px solid black; padding: 1vh;">Умения выполнять вычисления и преобразования</td>
                    <td style="border: 1px solid black; padding: 1vh;">88,8</td>
                </tr>
                <tr>
                    <td style="border: 1px solid black; padding: 1vh;">7</td>
                    <td style="border: 1px solid black; padding: 1vh;">Умения выполнять вычисления и преобразования</td>
                    <td style="border: 1px solid black; padding: 1vh;">69,8</td>
                </tr>
                </table>
                </p>
                <p>Главной задачей при изучении действий с положительными и отрицательными числами является формирование осознанного понимания алгоритмов вычислений. Вычислительные навыки у обучающихся считаются сформированными только в том случае, если они выполняют вычисления осознанно и быстро, применяя рациональные приемы, в тех случаях, когда это возможно.</p>
                <p>Изучение числовых множеств, а также и множества рациональных чисел, предусматривает прохождение следующих этапов: </p>
                <ol>
                    <li>необходимость использования нового множества чисел (мотивация);</li>
                    <li>введение нового множества чисел;</li>
                    <li>сравнение чисел;</li>
                    <li>действия над числами;</li>
                    <li>законы и свойства действий, специальные случаи действий; </li>
                    <li>текстовые задачи, решаемые с помощью действий, законов и свойств;</li>
                    <li>использование калькулятора в вычислениях; </li>
                    <li>обобщение и систематизация знаний. </li>
                </ol>
                <p>Такие же этапы проходят и при изучении множества рациональных чисел.</p>
                <p>Этапы 1-3 являются базовыми для изучения операций над рациональными числами. Формирование вычислительных умений начинается на этапе изучения действий над числами. </p>
                <p>Эффективность этого процесса зависит от целого ряда факторов: от индивидуальных особенностей школьника, уровня его математической подготовки, от организации  вычислительной деятельности.</p>
                
                
                `
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1012",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Глейзер Г.И. История математики в школе. IV-VI классы. – Москва: Просвещение, 1981",
                "Мельникова Н. Развитие вычислительной культуры учащихся // Математика в школе. – 2011",
                "Мерзляк  А.Г. и др. Математика. 6 класс. – Москва: Вентана-Граф, 2021",
                "Стефанова Н.Л. и др. Методика и технология обучения математике. Курс лекций. – Москва: Дрофа, 2008",
                "Федотова Л. Повышение вычислительной культуры учащихся // Математика в школе, 2008",
            ],
            historical: [
                "Концепция развития математического образования в Российской Федерации. – Распоряжение от 24 декабря 2013 г. № 2506-р. – [Электронный ресурс]. – Режим доступа: URL: http://static.government.ru/media/files/41d4b63b1dd474c16d7a.pdf   (дата обращения: 14.04.2023)",
                "Примерная рабочая программа основного общего образования. Математика. Базовый уровень (для 5–9 классов образовательных организаций). – [Электронный ресурс]. – Режим доступа: URL: https://edsoo.ru/Primernaya_rabochaya_programma_osnovnogo_obschego_obrazovaniya_predmeta_Matematika_proekt_.htm (дата обращения: 14.04.2023)",
            ],
            sites: [
                "Портал «Единое содержание общего образования». [Электронный ресурс]. – Режим доступа: https://edsoo.ru/ (дата обращения: 14.04.2023)",
                "Российская электронная школа. [Электронный ресурс]: режим доступа: https://resh.edu.ru/subject/51/10/ (дата обращения: 14.04.2023)",
                "Единая коллекция цифровых образовательных ресурсов. [Электронный ресурс]. – Режим доступа: http://school-collection.edu.ru/ (дата обращения: 14.04.2023)",
            ],
            filesToDownload: [
                {
                    link: "./files/mat1.pdf",
                    fileName: "Задания и тесты"
                },
                {
                    link: "./files/mat2.pdf",
                    fileName: "Возникновение отрицательных чисел"
                },
                {
                    link: "./files/mat3.pdf",
                    fileName: "Сложение рациональных чисел"
                }
            ]
        }
    ],
};
